import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <header className="header">
          <h1 className="title">Privacy Policy</h1>
          <h2 className="game-name">Levels Come Again - Troll Game</h2>
        </header>

        <section className="introduction">
          <p className="intro-text">
            This Privacy Policy describes how <strong>Levels Come Again - Troll Game</strong> ("we", "our", or "us"), 
            developed and published by <strong>xtendcode</strong>, handles information 
            when you use our mobile game. We are committed to protecting your privacy and ensuring you 
            have a positive experience while playing.
          </p>
          <p className="intro-text">
            By using <strong>Levels Come Again</strong>, you agree to the collection and use of information 
            in accordance with this policy.
          </p>
        </section>

        <section className="policy-section">
          <h3 className="section-title">Information Collection and Use</h3>
          <p className="section-text">
            We want to inform you that <strong>Levels Come Again</strong> does not collect, store, or 
            process any personal information from our users. Our game is designed to function without 
            requiring any personal data such as names, email addresses, phone numbers, or other 
            identifying information.
          </p>
          <p className="section-text highlight">
            You can enjoy all features of our game without providing any personal information whatsoever.
          </p>
        </section>

        <section className="policy-section">
          <h3 className="section-title">Log Data</h3>
          <p className="section-text">
            In case of errors or technical issues in the app, we may collect basic device information 
            through third-party services such as Firebase or Supabase. This log data may include 
            information such as your device's operating system, app version, the time and date of your 
            use of the service, and other diagnostic data.
          </p>
          <p className="section-text">
            This information is used solely for the purpose of identifying and fixing technical issues 
            to improve our service.
          </p>
        </section>

        <section className="policy-section">
          <h3 className="section-title">Cookies</h3>
          <p className="section-text">
            <strong>Levels Come Again</strong> does not use cookies or similar tracking technologies. 
            We do not store any information on your device that could be used to track your browsing 
            behavior or personal preferences.
          </p>
        </section>

        <section className="policy-section">
          <h3 className="section-title">Security</h3>
          <p className="section-text">
            We value your trust and strive to use commercially acceptable means of protecting any data 
            that may be processed. Our application is built using industry-standard security practices 
            and frameworks. However, remember that no method of transmission over the internet or method 
            of electronic storage is 100% secure.
          </p>
          <p className="section-text highlight">
            Since we don't collect personal information, the risk to your privacy is minimal.
          </p>
        </section>

        <section className="policy-section">
          <h3 className="section-title">Changes to This Privacy Policy</h3>
          <p className="section-text">
            We may update our Privacy Policy from time to time. We will notify you of any changes by 
            posting the new Privacy Policy on this page. You are advised to review this Privacy Policy 
            periodically for any changes.
          </p>
          <p className="section-text">
            Changes to this Privacy Policy are effective when they are posted on this page.
          </p>
        </section>

        <section className="policy-section contact-section">
          <h3 className="section-title">Contact Us</h3>
          <p className="section-text">
            If you have any questions or suggestions about our Privacy Policy, do not hesitate to 
            contact us at:
          </p>
          <div className="contact-info">
            <p className="contact-item">
              <span className="contact-icon">📧</span>
              <strong>Email:</strong> xtendcode@gmail.com
            </p>
          </div>
        </section>

        <footer className="footer">
          <p className="last-updated">
            <strong>Last updated:</strong> December 08, 2025
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;